import { createReducer } from '@reduxjs/toolkit';
import { appActions } from 'app/app.actions';
import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { userModalActions } from 'components/usersModal';
import { defaultFeatureFlags, } from 'utils/featureFlagging/featureFlags';
import { profileActions } from './settingsProfile.actions';
const initialState = {
    profile: {
        id: '',
        name: '',
        email: null,
        phone_number: null,
        avatar_url: '',
        roles: [],
        default_outbound_number: null,
        is_agent: true,
    },
    featureflags: defaultFeatureFlags,
};
export const profileReducer = createReducer(initialState, (builder) => builder
    .addCase(profileActions.update, (state, action) => {
    Object.assign(state.profile, action.payload.user);
})
    .addCase(websocketActions.createFulfilled, (state, action) => {
    Object.assign(state.profile, action.payload.params.user);
})
    .addCase(userModalActions.user.update.fulfilled, (state, action) => {
    if (action.payload.data.id === state.profile.id) {
        Object.assign(state.profile, action.payload.data);
    }
})
    .addCase(appActions.getFeatureFlags.fulfilled, (state, action) => {
    state.featureflags = action.payload.flags;
}));
